module.exports = __webpack_public_path__ + "static/img/bottom.96b81e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/bottom.png
// module id = 129r
// module chunks = 0